/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

var getStorageObject, setStorageObject, logping;
if (typeof require === "function") {
	var storage = require("../utils/Storage");
	getStorageObject = storage.getStorageObject;
	setStorageObject = storage.setStorageObject;
	var logging = require("../utils/log");
	logping = logging.logping;
}

/**
 * Store sent contribution messages (_not_ all messages!) until they are ACKed
 * IMPORTANT: store also in localStorage to survive app restarts
 *
 * In contrast to the OutBuffer, the messages stored here are delivered in any case after a new connection has been established
 *
 * @type {{...}}
 */
function PersistentMessageQueue(communication) {

	var queue = getStorageObject("PersistentMessageQueue", []);

	// --------------------------------- API ---------------------------------

	/**
	 * store message until acked
	 *
	 * Checks if this messageType needs to be stored:
	 * Only contributions and Module messages are important
	 *
	 */
	function storeMessage(messageId, messageType, payloadStringAsJson) {
		// store only messages that are not transient by type (which does not make any sense to be stored as they become irrelevant)
		// if not authenticated, just store all messages as they will be sent soon (authentication is set to false just before a reconnect)
		if (communication.isPersistentMessageType(messageType) || !communication.isAuthenticated()) {
			logping.trace("adding message with id: " + messageId + " to persistent queue");
			queue.push({id: messageId, messageType: messageType, payload: payloadStringAsJson});
			setStorageObject("PersistentMessageQueue", queue);
		}
	}

	/**
	 * remove all messages with IDs up to the given ackId
	 * when ACK received
	 *
	 * @param ackId the ack ID recieved
	 */
	function removeAckedMessages(ackId) {
		var changed = true;
		// start from end of queue to avoid messing up the index ...
		for (var i = queue.length - 1; i >= 0; i--) {
			// id < 0 means not sent yet
			if (queue[i].id >= 0 && queue[i].id <= ackId) {
				logping.trace("removing acknowledged message with id: " + queue[i].id + " from PersistentMessageQueue");
				queue.splice(i, 1);
				changed = true;
			}
		}

		if (changed) {
			setStorageObject("PersistentMessageQueue", queue);
		}
	}

	/**
	 * send all messages in queue
	 */
	function resendMessages() {
		if (queue.length === 0) { return; }
		logping.info("Going to sent ", queue.length, " messages in PersistentMessageQueue");

		// when using communication.sendMessage() be sure to avoid to queue the message twice
		var messagesToSendQueue = queue;
		// -> let's clean the queue first
		flush();

		for (var i in messagesToSendQueue) {
			// noinspection JSUnfilteredForInLoop
			var entry = messagesToSendQueue[i];
			var message = JSON.parse(entry.payload);
			communication.sendMessage(message, entry.messageType);
		}
	}

	/**
	 * cleanup old messages
	 */
	function flush() {
		queue = [];
		setStorageObject("PersistentMessageQueue", queue);
		logping.trace("flushed PersistentMessageQueue");
	}


// Public API
	return {
		storeMessage: storeMessage,
		removeAckedMessages: removeAckedMessages,
		resendMessages: resendMessages,
		flush: flush
	}
}

if (typeof module === "object") {
	module.exports = PersistentMessageQueue;
}
